<template>
  <div class="labelable">
    <label :class="[isPlaceholder, {required: isRequired}]"
           tabindex="0"
           @click="enableEditMode"
           @keydown.enter="enableEditMode"
           v-show="!isEditMode">{{labelTitle}}<required-indicator v-if="isRequired" /></label>
    <slot></slot>
    <expandable-textarea ref="textareaComponent"
                         :isShown="isEditMode"
                         @mousedown.stop
                         @blur="blur"
                         @paste="$emit('paste', $event)"
                         v-model.sync="localValue"
                         name="label_title"
                         v-on:keydown:enter="enter"
                         expandsHorizontally
                         :is-disabled="!canConfigure"
                         :placeholder="placeholder"></expandable-textarea>

  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import EditModeMixin from "../../../formability/form_builder/mixins/editModeMixin"
  import localValueEmissionMixin from "../../mixins/localValueEmissionMixin";

  export default Vue.extend({
    mixins: [EditModeMixin, localValueEmissionMixin],
    props: {
      placeholder: {
        default: 'Enter a label...'
      },
      isRequired: {
        type: Boolean,
        default: false,
      },
      isRestricted: {
        type: Boolean,
        default: false,
      },
      isSelected: {
        type: Boolean,
        default: false,
      },
      canConfigure: {
        type: Boolean,
        default: true,
      }
    },
    data: function() {
      return {
      };
    },
    mounted() {
      this.editModeRef = this.$refs.textareaComponent.$refs.textarea;
      if (this.isSelected) {
        this.editMode = true;
        this.$nextTick(() => {
          this.$refs.textareaComponent.focus();
        });
      }
    },
    methods: {
      enableEditMode() {
        if (this.isRestricted || !this.canConfigure) {
          return;
        }
        this.editMode = true;
        this.$nextTick(() => {
          this.$refs.textareaComponent.expand();
        });
      },
      blur(event) {
        this.editMode = false;
        this.$emit('blur', event);
      },
      enter: function(event) {
        this.editMode = false;
        this.$emit('keydown:enter', event);
      }
    },
    computed: {
      labelTitle: function() {
        if (this.localValue === null || this.localValue === undefined || this.localValue.length === 0) {
          return this.placeholder;
        }
        return this.localValue;
      },
      isEditMode: function() {
        return this.editMode;
      },
      isPlaceholder: function() {
        if (this.localValue === null || this.localValue === undefined || this.localValue.length === 0) {
          return 'placeholder';
        }
      }
    }
  });
</script>
